/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address",
            },
            {
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFT",
                type: "address",
            },
            {
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFT",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_ALREADY_EXISTS",
        type: "error",
    },
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_DOES_NOT_EXIST",
        type: "error",
    },
    {
        inputs: [],
        name: "SF_TOKEN_BURN_INSUFFICIENT_BALANCE",
        type: "error",
    },
    {
        inputs: [],
        name: "SF_TOKEN_MOVE_INSUFFICIENT_BALANCE",
        type: "error",
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_HOST",
        type: "error",
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_LISTED_AGREEMENT",
        type: "error",
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_APPROVE_FROM_ZERO_ADDRESS",
        type: "error",
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_APPROVE_TO_ZERO_ADDRESS",
        type: "error",
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_BURN_FROM_ZERO_ADDRESS",
        type: "error",
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_CALLER_IS_NOT_OPERATOR_FOR_HOLDER",
        type: "error",
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_INFLATIONARY_DEFLATIONARY_NOT_SUPPORTED",
        type: "error",
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_MINT_TO_ZERO_ADDRESS",
        type: "error",
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NFT_PROXY_ADDRESS_CHANGED",
        type: "error",
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NOT_ERC777_TOKENS_RECIPIENT",
        type: "error",
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NO_UNDERLYING_TOKEN",
        type: "error",
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_ADMIN",
        type: "error",
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_GOV_OWNER",
        type: "error",
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_SELF",
        type: "error",
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_TRANSFER_FROM_ZERO_ADDRESS",
        type: "error",
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_TRANSFER_TO_ZERO_ADDRESS",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldAdmin",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]",
            },
        ],
        name: "AgreementCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "rewardAccount",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256",
            },
        ],
        name: "AgreementLiquidated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "bondAccount",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256",
            },
        ],
        name: "AgreementLiquidatedBy",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "targetAccount",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "rewardAmountReceiver",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes",
            },
        ],
        name: "AgreementLiquidatedV2",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "slotId",
                type: "uint256",
            },
        ],
        name: "AgreementStateUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "AgreementTerminated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]",
            },
        ],
        name: "AgreementUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenHolder",
                type: "address",
            },
        ],
        name: "AuthorizedOperator",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bailoutAccount",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256",
            },
        ],
        name: "Bailout",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes",
            },
        ],
        name: "Burned",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address",
            },
        ],
        name: "CodeUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFT",
                type: "address",
            },
        ],
        name: "ConstantInflowNFTCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFT",
                type: "address",
            },
        ],
        name: "ConstantOutflowNFTCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes",
            },
        ],
        name: "Minted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenHolder",
                type: "address",
            },
        ],
        name: "RevokedOperator",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes",
            },
        ],
        name: "Sent",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "TokenDowngraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "TokenUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "CONSTANT_INFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantInflowNFT",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "CONSTANT_OUTFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantOutflowNFT",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "authorizeOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "changeAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]",
            },
        ],
        name: "createAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultOperators",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "downgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "downgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getAccountActiveAgreements",
        outputs: [
            {
                internalType: "contract ISuperAgreement[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256",
            },
        ],
        name: "getAgreementData",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256",
            },
        ],
        name: "getAgreementStateSlot",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "host",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getUnderlyingDecimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getUnderlyingToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "granularity",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "underlyingToken",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "n",
                type: "string",
            },
            {
                internalType: "string",
                name: "s",
                type: "string",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "underlyingToken",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "n",
                type: "string",
            },
            {
                internalType: "string",
                name: "s",
                type: "string",
            },
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
        ],
        name: "initializeWithAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        name: "isAccountCritical",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "isAccountCriticalNow",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        name: "isAccountSolvent",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "isAccountSolventNow",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenHolder",
                type: "address",
            },
        ],
        name: "isOperatorFor",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "liquidatorAccount",
                type: "address",
            },
            {
                internalType: "bool",
                name: "useDefaultRewardAccount",
                type: "bool",
            },
            {
                internalType: "address",
                name: "targetAccount",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256",
            },
            {
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256",
            },
        ],
        name: "makeLiquidationPayoutsV2",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "operationApprove",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "operationDecreaseAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "operationDowngrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "operationIncreaseAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "operationSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "operationTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "operationUpgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes",
            },
        ],
        name: "operatorBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes",
            },
        ],
        name: "operatorSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "realtimeBalanceOfNow",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "revokeOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "selfApproveFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "selfBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "selfMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "selfTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "send",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "int256",
                name: "delta",
                type: "int256",
            },
        ],
        name: "settleBalance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256",
            },
        ],
        name: "terminateAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "toUnderlyingAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "underlyingAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "adjustedAmount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
        ],
        name: "transferAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]",
            },
        ],
        name: "updateAgreementData",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256",
            },
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]",
            },
        ],
        name: "updateAgreementStateSlot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class SuperToken__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(host, constantOutflowNFT, constantInflowNFT, overrides) {
        return super.deploy(host, constantOutflowNFT, constantInflowNFT, overrides || {});
    }
    getDeployTransaction(host, constantOutflowNFT, constantInflowNFT, overrides) {
        return super.getDeployTransaction(host, constantOutflowNFT, constantInflowNFT, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
SuperToken__factory.bytecode = _bytecode;
SuperToken__factory.abi = _abi;
//# sourceMappingURL=SuperToken__factory.js.map